import type { ColDef } from 'ag-grid-community';
import {
  CustodianCellEditor,
  CustodianCellRenderer,
} from 'components/shared/Blotter/Grid/CellRenderers/CustodianCellEditor';
import { editableContentCellRendererFactory } from 'components/shared/Blotter/Grid/CellRenderers/EditableContentCellRenderer';
import { useMemo } from 'react';
import { getEditInfoForProductField } from 'state/secondaryMarket/productSearch/productSearch.selectors';

export function useEditableCustodianColumnType(): ColDef {
  return useMemo(
    () => ({
      cellEditor: CustodianCellEditor,
      cellRenderer: editableContentCellRendererFactory(getEditInfoForProductField, CustodianCellRenderer),
    }),
    [],
  );
}
